import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { microAppInitialized } from '@mynexus/mfe-core';

@Component({
    selector: 'app-sdoh',
    templateUrl: './mnc-sdoh.component.html',
    styleUrls: ['./mnc-sdoh.component.scss'],
    standalone: false
})
export class MncSDoHComponent implements AfterViewInit {
  constructor(
    private readonly ref: ElementRef,
    private readonly router: Router
  ) {
    // this is required to trigger the router for the micro app on initial load.
    this.router.initialNavigation();
    
    // this deals with a bug where if you navigate away from the MFE
    // the router gets out of sync with the url.
    this.router.navigateByUrl(window.location.pathname);
  }

  @Input() set url(value: string) {
    this.router.navigate([value]);
  }

  public ngAfterViewInit(): void {
    microAppInitialized(this.ref, this.router, 'SDoH')
  }
}
